import { render, staticRenderFns } from "./news-list-filter-app.vue?vue&type=template&id=53d2c502&"
import script from "./news-list-filter-app.vue?vue&type=script&lang=js&"
export * from "./news-list-filter-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports